// Pretty input file styling
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.pretty-input-file input[type="file"]').forEach((input) => {
    const label = input.closest('div').querySelector('label')
    if (!label) return

    const labelVal = label.innerHTML

    input.addEventListener('change', (e) => {
      let fileName = ''

      if (e.target.files && e.target.files.length > 0) {
        fileName = e.target.value.split('\\').pop()
      }

      if (fileName) {
        label.innerHTML = fileName
      } else {
        label.innerHTML = labelVal
      }
    })
  })
})

